import { jsx } from "react/jsx-runtime";
import { Button as MUIButton, CircularProgress } from "@mui/material";
import { forwardRef, useCallback } from "react";
const ButtonInner = ({
  onMouseUp,
  loading = false,
  loadingPosition = "start",
  disabled,
  children,
  startIcon,
  endIcon,
  ...restProps
}, ref) => {
  const handleMouseUp = useCallback(
    (event) => {
      event.currentTarget.blur();
      onMouseUp?.(event);
    },
    [onMouseUp]
  );
  const EndIcon = loading && loadingPosition === "end" ? /* @__PURE__ */ jsx(CircularProgress, { size: "1em" }) : endIcon;
  const StartIcon = loading && loadingPosition === "start" ? /* @__PURE__ */ jsx(CircularProgress, { size: "1em" }) : startIcon;
  return /* @__PURE__ */ jsx(
    MUIButton,
    {
      "data-testid": "biome-button",
      disabled: loading || disabled,
      endIcon: EndIcon,
      onMouseUp: handleMouseUp,
      startIcon: StartIcon,
      ...restProps,
      ref,
      children
    }
  );
};
const Button = forwardRef(ButtonInner);
export {
  Button
};
